import React, { useCallback, useRef, useState, useEffect, useMemo, Suspense } from 'react';
import useSWR, {mutate} from 'swr'; //　20240808　mutate追加
import clsx from 'clsx';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { GoogleMap, Marker, Polyline, HeatmapLayer, useJsApiLoader } from '@react-google-maps/api';
import { useCookies } from 'react-cookie';
import Cookies from 'universal-cookie'
import { Scrollbars } from 'react-custom-scrollbars';
import { Oval } from 'react-loader-spinner'
import { IconHome, IconPlus, IconMinus, IconLayers, IconClose, IconGrid, IconBox } from 'src/icons';
import { Radio, Checkbox, RadiosWrap, Table, AnimalMarker, Button, TrapMarker, CameraMarker, DamageMarker, IndpinMarker } from 'src/components';
import { ecology, vermin_category} from 'src/utils/choises';
import { useDrop, useVermins, useEditMode, useCreateModal, useEditData, useLineMode} from 'src/stores';
import {
  picBoar,
  picBear,
  picDeer,
  picMonkey,
  imgRoadmap,
  imgSatellite,
  imgHybrid,
  imgTerrain,
  imgHousing,
  //imgOSM,//追加日230920
  markerCircle,
  picPin,
  picRaccoon,//231004追加
  picPalmcivet,//231004追加
  picOther,//240517追加
} from 'src/images';
//230407追加
import styles from './Home.module.scss';
import axios from 'axios';
//230413追加
import { useNavigate } from 'react-router-dom'

let geoString = {
  "type": "FeatureCollection",
  "name": "testLine",
  "features": [
    //{ "type": "Feature", "properties": { "id": 0, "prev_faci_type_id": -1, "prev_faci_type_name": "\u30ef\u30a4\u30e4\u30fc\u30e1\u30c3\u30b7\u30e5", ,"prev_faci_deleted": false }, "geometry": { "type": "LineString", "coordinates": [[140.705477863604, 38.3623920600735], [140.704228659188, 38.3622501050262], [140.704824870387, 38.3607737725348], [140.705591427642, 38.3608873365726], [140.705648209661, 38.3621933230073], [140.705648209661, 38.3621933230073]] } },
    { "type": "Feature", "properties": { "id": 0, "prev_faci_type_id": -1, "prev_faci_type_name": "\u30ef\u30a4\u30e4\u30fc\u30e1\u30c3\u30b7\u30e5", "prev_faci_client":1380001004696,"prev_faci_displayability": 5,"prev_faci_deleted": false }, "geometry": { "type": "LineString", "coordinates": [[0.000477863604, 0.0003920600735], [0.01, 0.01], [0.02, 0.02], [0.03, 0.03], [0.04, 0.04], [0, 0]] } },
  ]
};

const geodatas = geoString;
// 初期zoom値
const initialZoom = 12;

// GoogleMap オプション値
const googleMapOptions = {
  maxZoom: 18,
  minZoom: 8,
  zoomControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  streetViewControl: false,
  styles: [
    {
      featureType: 'poi', // 観光施設や学校・講演などのスポット
      elementType: 'labels', // 建物のラベルやアイコン
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road', // 道路
      elementType: 'labels', // 建物のラベルやアイコン
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape', // 山や砂漠などの風景情報
      elementType: 'labels', // 建物のラベルやアイコン
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit', // 公共交通機関（電車の路線や駅）
      elementType: 'labels', // 建物のラベルやアイコン
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water', // 水域
      elementType: 'labels', // 建物のラベルやアイコン
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ],
};

type FormValues = {
  keyword: string;
  start_day: string;
  end_day: string;
  start_time: string;
  end_time: string;
  time_zone: string[];
};//20220929

// 検索結果一覧の各データの型
export type Vermin = {
  mesh_number: string;
  trap_hunting_name: string;
  vermin_address: string;
  vermin_count: number;
  vermin_herd: string;
  vermin_discovery_date: string;
  vermin_discovery_time: string;
  vermin_ecology_name: string;
  vermin_ecology: string;
  vermin_displayability_name: string;
  vermin_is_deleted: boolean;
  vermin_geom: {
    coordinates: {
      latitude: string;
      longitude: string;
    };
  };
  vermin_latitude: string;
  vermin_longitude: string;
  vermin_id: number;
  vermin_kind_id: number;
  vermin_kind_name: string;
  vermin_register_date: string;
  vermin_remarks: string;
  vermin_update_date: string;
  trap_id: number;
  vermin_picture: string;//20230407追記
  camera_id: number;
  update_user_id: number;
  update_user_name: string;
  client_code: number;
  
  report_id: number;//20240416 Add Uduki
};

// 罠一覧の各データの型
export type Trap = {
  mesh_number: string;
  trap_hunting_name: string;
  trap_admin: string;
  trap_admin_tel: string;
  trap_address: string;
  trap_count: number;
  trap_start: string;
  trap_stop: string;
  trap_deleted: boolean;
  trap_result: string;
  trap_log_latitude: string;
  trap_log_longitude: string;
  trap_latitude: string;
  trap_longitude: string;
  camera_id: string;
  trap_id: number;
  trap_register_date: string;
  trap_update_date: string;
  vermin_kind_name: string;
  trap_remarks: string;
  trap_mistake: boolean;
  trap_mistake_log: string;
  trap_hunting_id: number;
  vermin_kind_id: number;
  trap_displayability: string;
  update_user_id: number;
  update_user_name: string;
  client_code: number;
};

// カメラ一覧の各データの型
export type Camera = {
  camera_direction: string;
  trap_id: number;
  camera_start: string;
  camera_stop: string;
  camera_remarks: string;
  camera_deleted: boolean;
  camera_latitude: string;
  camera_longitude: string;
  camera_id: number;
  camera_register_date: string;
  camera_update_date: string;
  camera_displayability: string;
  update_user_id: number;
  update_user_name: string;
  client_code: number;
};

// 被害一覧の各データの型
export type Damage = {
  damage_id: number;
  damage_type_name: string;
  damage_type_id: number;
  vermin_kind_name: string;
  discovery_date: string;
  discovery_time: string;
  // damage_is_deleted: boolean
  damage_latitude: string;
  damage_longitude: string;
  damage_implementation_date: string;
  damage_implementation_name: string;
  damage_countermeasures: string;
  damage_remarks: string;
  vermin_kind_id: number;
  damage_discovery_date: string;
  damage_contents: string;
  damage_implementation: string
  damage_implementation_time: string;
  // damage_implementation_name: string;
  damage_displayability: string;
  damage_deleted: boolean;
  damage_update_date: string;
  update_user_id: number;
  update_user_name: string;
  damage_displayability_name: string;
  client_code: number;
    
  report_id: number;//20240416 Add Uduki
};

// 指示ピンの各データの型
export type Indpin = {
  indpin_id: number;
  indpin_label: string;
  indpin_deleted: boolean
  indpin_latitude: string;
  indpin_longitude: string;
  indpin_comment: string; // 20250417 Add Uduki
  indpin_displayability: string;
  indpin_displayability_name: string;
  client_code: number;
  register_user_id: number;
};

export type Limit_Kinds = {//231017追記
  lk_kind:number;
  lk_limit:string;
}

let verminIds: number[] = []; //20280808土屋追加
let geoS_C = 0;
let Hdata: { location: any; weight: number; }[];
let Current_data_lat:number | undefined = undefined;
let Current_data_lon:number | undefined = undefined;
let Current_data_lat_IP:number | undefined = undefined;
let Current_data_lon_IP:number | undefined = undefined;
let data: { features: any; limit: string; limit_kinds: any; client_dps_flg: boolean;};//limit_kinds231017追記
let data_Days: { features: any; limit: string; limit_kinds: any;};//20240808追記
let trap_d: { features: any; };
let camera_d: { features: any; };
let damage_d: { features: any; };
//230419追加
let co_na:number | null = null;
const params = new URLSearchParams(window.location.search);
if(params.has("corporate")&&Number(params.get("corporate"))){
  co_na = Number(params.get("corporate"));
}else{
  co_na = null;
}
let limit:string | null = null;
let Current_select_lat:number | undefined = undefined;
let Current_select_lon:number | undefined = undefined;
if(45.557222>Number(params.get("S_lat"))&&153.986667>Number(params.get("S_lon"))
  &&20.425278<Number(params.get("S_lat"))&& 122.9325<Number(params.get("S_lon"))){
  Current_select_lat = Number(params.get("S_lat"));
  Current_select_lon = Number(params.get("S_lon"));
}

//231005_初期表示の害獣選択
const Animal_Kind = ["1", "2", "3", "4", "5", "6", "7"]//順番変更サル⇔シカ20231018
const Other_Kind: string[] = [];
const Damage_Kind: string[] = [];
let First_Animal: string[] = [];
let SelectAN_Check = false;
// 図形の表示非表示制御系_範囲指定
let shapedisplaycontrol : number[] = [];
let SelectAN_STR = params.get("SelectAN");
if(SelectAN_STR && SelectAN_STR.match(/^[0-9,]+$/)){
  const SelectAN_SET = SelectAN_STR.split(",");
  Animal_Kind.forEach((element) => {
    if(SelectAN_SET.includes(element)){
      First_Animal.push(element);
    }
  });
} else {
  First_Animal = Animal_Kind;
  Other_Kind.push('罠', 'カメラ','指示ピン');
  Damage_Kind.push('1', '2', '4', '5');
  shapedisplaycontrol.push(0, 1, 2, 3, 4);
  SelectAN_Check = true;
  SelectAN_STR = null;
}

let color_gradion = [
  'rgba(255, 0, 0, 0)',
  ];
for (let i=0; i<86 ; i++){
  let color_gradion2 = ['rgba(255, 0, 0, '+((50+(i/17)*10)/100)+')']
  color_gradion = color_gradion.concat(color_gradion2);
}
for (let i=0; i<86 ; i++){
  let color_gradion2 = ['rgba('+(255-i)+', 0, 0, 1)']
  color_gradion = color_gradion.concat(color_gradion2);
}

// HeatMap オプション値
const heatMapOptions = {
  radius: 25,
  gradient: color_gradion,
  opacity: 1,
};

// 2025/04/17 現在位置アイコン設定
let myAicon = false;

axios.get(`${process.env.REACT_APP_DEV_API_URL}/map_visit`);

/**
 * Home コンポーネント
 * おもにマップ機能を提供
 * @returns React.ReactNode
 */
const Home: React.FC = () => {
  const [cookie,setCookie] = useCookies()
  const cookies = new Cookies();

  const { reset } = useForm<FormValues>();//20220929
    
  // 初期センター座標
  const initialCenter = useMemo(() => {
    const userCenter = {
      lat:
        Current_select_lat ||
        Current_data_lat ||
        +cookie?.verminData?.client_latitude || 
        Current_data_lat_IP ||
        Number(`${process.env.REACT_APP_LAST_LAT}`),
        //38.2682009,
      lng:
        Current_select_lon ||
        Current_data_lon ||
        +cookie?.verminData?.client_longitude ||
        Current_data_lon_IP ||
        Number(`${process.env.REACT_APP_LAST_LON}`),
        //140.8694255,
    }
    return userCenter;
  }, [cookie])
  /**
   * 　位置情報の取得処理
   */
  const Get_Current_Date = () =>{
    // 2025/04/17 Add Uduki 現在地アイコン用追加
    myAicon = false;
    if( navigator.geolocation ){
      // 現在地を取得
      navigator.geolocation.getCurrentPosition(
      // [第1引数] 取得に成功した場合の関数
        function( position ){
          // 取得したデータの整理
          const Current_data = position.coords ;
          //変数に位置情報記録
          Current_data_lat = Current_data.latitude;
          Current_data_lon = Current_data.longitude;
          // クッキーの期限を設定
          const cookieDate = new Date();
          // 現在時刻を取得
          cookieDate.setMinutes( cookieDate.getMinutes() + 5);
          //initialCenter実行の為cookieに文字列追加
          setCookie('Position_Permission',"Allow", { expires: cookieDate });
          cookies.remove('Position_Permission');
          // 2025/04/17 Add Uduki 現在地アイコン用追加
          myAicon = true;
        },
        // [第2引数] 取得に失敗した場合の関数
        function(){
          //230427追加_IPアドレスの取得
          axios.get(`https://ipapi.co/json/`).then( ipdata => {
            const IP = ipdata.data.ip;
            //IPドメインから位置情報取得
            axios.get(`${process.env.REACT_APP_DEV_API_URL}/ip/position`, {params: {co_na,IP},})
              .then( data => {
              //位置情報の取得に成功したかどうか
              if(data.data.result == 'success'){
              //変数に位置情報記録
                Current_data_lat_IP = Number(data.data.lat);
                Current_data_lon_IP = Number(data.data.lon);
                // クッキーの期限を設定
                const cookieDate = new Date();
                // 現在時刻を取得
                cookieDate.setMinutes( cookieDate.getMinutes() + 5);
                //initialCenter実行の為cookieに文字列追加
                setCookie('Position_Permission',"Allow", { expires: cookieDate });
                cookies.remove('Position_Permission');
              } else {
                //失敗したことを伝える
                Current_data_lat = undefined; 
                Current_data_lon = undefined;
                Current_data_lat_IP = undefined; 
                Current_data_lon_IP = undefined;
              }
            })
          })
        }
      )
    } else {
      //230427追加IPアドレスの取得
      axios.get(`https://ipapi.co/json/`).then( ipdata => {
        const IP = ipdata.data.ip;
        axios.get(`${process.env.REACT_APP_DEV_API_URL}/ip/position`, {params: {co_na,IP},})
        .then( data => {
          //位置情報の取得に成功したかどうか
          if(data.data.result == 'success'){
            //変数に位置情報記録
            Current_data_lat_IP = Number(data.data.lat);
            Current_data_lon_IP = Number(data.data.lon);
            // クッキーの期限を設定
            const cookieDate = new Date();
            // 現在時刻を取得
            cookieDate.setMinutes( cookieDate.getMinutes() + 5);
            //initialCenter実行の為cookieに文字列追加
            setCookie('Position_Permission',"Allow", { expires: cookieDate });
            cookies.remove('Position_Permission');
          } else {
            //失敗した場合
            Current_data_lat_IP = undefined; 
            Current_data_lon_IP = undefined;
          }
        })
      })
    }
  };
  
  //ページ更新時一度だけ走る処理
  useMemo(() => {
    Get_Current_Date()
  }, []);
  /**
   * GoogleAnalytics用トラッキング
   */
  useEffect(() => {
    window.gtag !== undefined && window.gtag('config', `${process.env.REACT_APP_DEV_TRACKING_ID}`, { page_path: window.location.pathname });
  }, []);

  /**
   * 認証トークンあれば格納
   */
  const headers = {
    headers: {
      Authorization: `Bearer ${cookie?.verminData?.api_token}`
    }
  }

  /**
   * トークンが認証切れかどうか判定（useSWRでは判断しづらいと考えたため）
   */
  useEffect(() => {
    if (cookie?.verminData?.api_token) {
      axios.get(`${process.env.REACT_APP_DEV_API_URL}/vermin-marker`, {
        headers: { 
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
         }}).then((res) => { 
        console.log(res.status);
        }).catch(async (err) => {
        if (err?.response?.data?.message === "Unauthenticated.") {
          await deleteVermins();
          await deleteIds();
          searchE();
          await cookies.remove('verminData');
          await window.location.replace('/')
        }
      })
    }
  }, []);

  //add-s 20240819 Tsuchiya Akane
  //upd-s 20240930 Tsuchiya Akane
  //let clientDpsFlg;
  const [clientDpsFlg, setDpsFlg] = useState(undefined);
  const [reload, setreload] = useState(false);
 
  //upd-e 20240930
  
    /**
   * 鳥獣害情報取得 API リクエスト（直近期間指定）
   */
    const handleLatestSearch = (day:number) => {
      reset(); // Add Uduki 検索結果の部分的な初期化
      searchE(); // Add Uduki 検索結果の部分的な初期化
      deleteProc(); // Add Uduki 検索結果の部分的な初期化
      const loginDate = new Date();
      let start_date = new Date();
      start_date.setDate(loginDate.getDate() - day);
      const formattedStartDate = start_date.toLocaleDateString();
      const formattedEndDate = loginDate.toLocaleDateString();
      // const procs = "vermin";
        if (!cookie?.verminData) {
          axios.get(`${process.env.REACT_APP_DEV_API_URL}/vermins/search`, {
            params: {
              start_date: formattedStartDate,
              end_date: formattedEndDate,
              proc:"vermin", // 20250418 upd Uduki
            }
          },
          ).then((res) => {
            data.features = res.data.result; // 取得したIDの配列
            // setProc(procs);
          }).catch(async err => {
            if (err?.response?.data?.message === "Unauthenticated.") {
              await cookies.remove('verminData');
              await window.location.replace('/');
            }
          })
          // 2025/04/08 Add Uduki
          axios.get(`${process.env.REACT_APP_DEV_API_URL}/vermins/search`, {
            params: {
              start_date: formattedStartDate,
              end_date: formattedEndDate,
              proc:"damage",
            }
          },
          ).then((res) => {
            damage_d.features = res.data.result; // 取得したIDの配列
          }).catch(async err => {
            if (err?.response?.data?.message === "Unauthenticated.") {
              await cookies.remove('verminData');
              await window.location.replace('/');
            }
          })
          axios.get(`${process.env.REACT_APP_DEV_API_URL}/vermins/search`, {
            params: {
              start_date: formattedStartDate,
              end_date: formattedEndDate,
              proc:"camera",
            }
          },
          ).then((res) => {
            camera_d.features = res.data.result; // 取得したIDの配列
          }).catch(async err => {
            if (err?.response?.data?.message === "Unauthenticated.") {
              await cookies.remove('verminData');
              await window.location.replace('/');
            }
          })
          axios.get(`${process.env.REACT_APP_DEV_API_URL}/vermins/search`, {
            params: {
              start_date: formattedStartDate,
              end_date: formattedEndDate,
              proc:"trap",
            }
          },
          ).then((res) => {
            trap_d.features = res.data.result; // 取得したIDの配列
          }).catch(async err => {
            if (err?.response?.data?.message === "Unauthenticated.") {
              await cookies.remove('verminData');
              await window.location.replace('/');
            }
          })
          //ログイン時のAPI
        } else {
          axios.get(`${process.env.REACT_APP_DEV_API_URL}/search-data/vermin`, {//20240827 Update Uduki
            params: {
              start_date: formattedStartDate,
              end_date: formattedEndDate,
              client_code: cookie?.verminData?.client_code,
            },
            headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` }
          },
          ).then((res) => {
            data.features = res.data.results; // 取得したIDの配列
            // setProc(procs);

          }).catch(async err => {
            if (err?.response?.data?.message === "Unauthenticated.") {
              await cookies.remove('verminData');
              await window.location.replace('/')
            }
          })
          //20240827 Add Uduki
          axios.get(`${process.env.REACT_APP_DEV_API_URL}/search-data/damage`, {
            params: {
              start_date: formattedStartDate,
              end_date: formattedEndDate,
              client_code: cookie?.verminData?.client_code,
            },
            headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` }
          },
          ).then((res) => {
            damage_d.features = res.data.results; // 取得したIDの配列
          }).catch(async err => {
            if (err?.response?.data?.message === "Unauthenticated.") {
              await cookies.remove('verminData');
              await window.location.replace('/')
            }
          })
          axios.get(`${process.env.REACT_APP_DEV_API_URL}/search-data/camera`, {
            params: {
              start_date: formattedStartDate,
              end_date: formattedEndDate,
              client_code: cookie?.verminData?.client_code,
            },
            headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` }
          },
          ).then((res) => {
            camera_d.features = res.data.results; // 取得したIDの配列
          }).catch(async err => {
            if (err?.response?.data?.message === "Unauthenticated.") {
              await cookies.remove('verminData');
              await window.location.replace('/')
            }
          })
          axios.get(`${process.env.REACT_APP_DEV_API_URL}/search-data/trap`, {
            params: {
              start_date: formattedStartDate,
              end_date: formattedEndDate,
              client_code: cookie?.verminData?.client_code,
            },
            headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` }
          },
          ).then((res) => {
            trap_d.features = res.data.results; // 取得したIDの配列
          }).catch(async err => {
            if (err?.response?.data?.message === "Unauthenticated.") {
              await cookies.remove('verminData');
              await window.location.replace('/')
            }
          })
        }
        setreload(true);
        
    };
  
    // 画面反映用変数　20240808 Uduki
    useEffect(() => {
      if(reload){
        setreload(false);
      }
    },[reload]);

    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    };
  //add-e 20240819

  // 2025/04/17 Add Uduki 現在地アイコン更新
  const [myAiconCount, setMyAiconCount] = useState(0);
  const [myAiconlatlng, setMyAiconlatlng] = useState({lat: 0, lng: 0});
  useEffect(() => {
    let timeoutId = setTimeout(() => {
      if(myAicon) {
        // console.log('現在地更新');
        // 現在地を取得
        navigator.geolocation.getCurrentPosition(
          // [第1引数] 取得に成功した場合の関数
            function( position ){
              // 取得したデータの整理
              const Current_data = position.coords ;
              let newMylat = 0
              let newMylng = 0
              // 現在地アイコンの位置情報を更新
              if(typeof Current_data.latitude === "number"){
                newMylat = Current_data.latitude;
              }
              if(typeof Current_data.latitude === "number"){
                newMylng = Current_data.longitude;
              }
              if (newMylat !== 0  && newMylng !== 0) {
                setMyAiconlatlng({lat:newMylat,lng:newMylng});
                // console.log(myAiconlatlng)
              }
            }
        )
        setMyAiconCount(myAiconCount + 1);
      }
    }, 2 * 1000);
    // こういう処理を書く
    return () => {
      clearTimeout(timeoutId)
    }
  },[myAiconCount]);
  
  const [myAiconSize, setMyAiconSize] = useState({stroke: 2, scale: 7 ,scaleDown:true});
  useEffect(() => {
    if(myAicon) {
		const interval = setInterval(() => {
        // console.log("現在地アイコンサイズ修正");
        let nStroke = myAiconSize.stroke - 0.2;
        let nScale = myAiconSize.scale + 0.1;
        let nDown = myAiconSize.scaleDown;
        if (nDown){
          nStroke = myAiconSize.stroke + 0.2;
          nScale = myAiconSize.scale - 0.1;
          if ( nScale <= 6) {
            nDown = false
          } 
        } else {
          if ( nScale >= 7) {
            nDown = true
          }
        }
        setMyAiconSize({stroke:nStroke,scale:nScale,scaleDown:nDown});
        // console.log(myAiconSize);
		  }, 100);
		  return () => clearInterval(interval);
    }
	}, [myAicon,myAiconSize]);
  
  // 2025/04/17 Add END

    /**
   * 鳥獣害情報一括取得 API リクエスト
   */
  const { data: data2 } = useSWR(cookie?.verminData?.api_token ? [`${process.env.REACT_APP_DEV_API_URL}/vermin-marker`, headers] : `${process.env.REACT_APP_DEV_API_URL}/vermins?corporate=${co_na}`);

  /**
   * 罠情報一括取得 API リクエスト
   */
  const { data: trap_d2 } = useSWR(cookie?.verminData?.api_token ? [`${process.env.REACT_APP_DEV_API_URL}/trap-marker`, headers] : `${process.env.REACT_APP_DEV_API_URL}/traps?corporate=${co_na}`);

  /**
   * 鳥獣害対策施設一括取得 API リクエスト
   */
  const { data: geoString2 } = useSWR(cookie?.verminData?.api_token ? [`${process.env.REACT_APP_DEV_API_URL}/prev-marker`, headers] : `${process.env.REACT_APP_DEV_API_URL}/equipments?corporate=${co_na}`, { loadingTimeout: 200000 });
  //const { data: geoString2 } = useSWR(`${process.env.REACT_APP_DEV_API_URL}/equipments?corporate=${co_na}`, { loadingTimeout: 200000 });
  /**
   * カメラ情報一括取得 API リクエスト
   */
  const { data: camera_d2 } = useSWR(cookie?.verminData?.api_token ? [`${process.env.REACT_APP_DEV_API_URL}/camera-marker`, headers] : `${process.env.REACT_APP_DEV_API_URL}/cameras?corporate=${co_na}`);

  /**
 * 被害情報一括取得 API リクエスト
 */
  const { data: damage_d2 } = useSWR(cookie?.verminData?.api_token ? [`${process.env.REACT_APP_DEV_API_URL}/damage-marker`, headers] : `${process.env.REACT_APP_DEV_API_URL}/damage_info?corporate=${co_na}`);

 /**
 * 指示ピン情報一括取得 API リクエスト
 */
 const { data: indpin_d } = useSWR(cookie?.verminData?.api_token ? [`${process.env.REACT_APP_DEV_API_URL}/indpin-marker`, headers] : `${process.env.REACT_APP_DEV_API_URL}/indpin?corporate=${co_na}`);


  /**
   * 捕獲頭数の取得
   */
  const { data: catch_count } = useSWR(`${process.env.REACT_APP_DEV_API_URL}/catch_count`)

  /**
   * 撮影頭数の取得
   */
  const { data: photo_count } = useSWR(`${process.env.REACT_APP_DEV_API_URL}/photo_count`)

  /**
   * フォームを管理するカスタムフック
   * 鳥獣害種別の操作を監視する state を用意
   */
  const { watch, register,setValue } = useForm({
    defaultValues: {
      kinds: First_Animal.concat(Other_Kind),
      d_kinds: Damage_Kind,
      ecology: ['捕獲', '観察', '狩猟', '目撃', '足跡', '糞便', '食痕', '掘り起こし', '錯誤捕獲', 'テレメトリー'],
    },
  });
  const watchKinds = watch('kinds');
  const watchKinds_d = watch('d_kinds')
  const watchEcology = watch('ecology');

  /**
   * フォームを管理するカスタムフック
   * フォーマットタイプの操作を監視する state を用意
   */
  const { watch: watch_f, register: register_f } = useForm({
    defaultValues: {
      kinds: ['0', '1'],
    },
  });
  const watchKinds_f = watch_f('kinds');

  /**
   * 詳細検索ボックスを閉じるメソッドを代入
   */
  const dropClose = useDrop(state => state.dropClose);

  /**
   * 検索結果管理ストアのセッター
   */
  const [vermins, proc, ids, searchCheck, deleteVermins, deleteIds, searchE, setProc, deleteProc] = useVermins(state => [state.vermins, state.proc, state.ids, state.searchCheck, state.deleteVermins, state.deleteIds, state.searchE, state.setProc, state.deleteProc]);

  
  /**
   * 編集モード
   */
  const [isEditMode, setEditModeClose] = useEditMode(state => [state.isEditMode, state.setEditModeClose]);

  /**
   *　線編集モード
   */
  const [isLineMode, setLineModeClose] = useLineMode(state => [state.isLineMode, state.setLineModeClose]);

  /**
   * 情報登録モーダルフラグ
   */
  const [createModalToggle, createDamageModalOpen, createIndpinModalOpen, createTrapModalOpen, createCameraModalOpen, createPrevModalOpen] = useCreateModal(state => [state.createModalToggle, state.createDamageModalOpen, state.createIndpinModalOpen, state.createTrapModalOpen, state.createCameraModalOpen, state.createPrevModalOpen]);

  /**
 * 編集モード時選択した地点の座標保存
 */
  const [setLatLng, deleteLatLng, Line, setLines, deleteLines, Page] = useEditData(state => [state.setLatLng, state.deleteLatLng, state.Line, state.setLine, state.deleteLine, state.Page]);

  /**
   * Maps インスタンスオブジェクト格納用
   */
  const googleMap = useRef<any>(null!);

  /**
   * ドロワーボックス開閉状態
   */
  const [drawerOpen, setDrawerOpen] = useState(false);

  /**
   * 背景地図選択ボックスのポップアップ状態
   */
  const [popup, setPopup] = useState(false);

  /**
   * Marker のアクティブ状態
   * クリックした Marker の vermin_id をセットする
   * @example
   * setVerminId([vermin_id])
   */
  const [verminId, setVerminId] = useState<number | null>(null);

  /**
   * Marker のアクティブ状態
   * クリックした Marker の trap_id をセットする
   * @example
   * setTrapId([trap_id])
   */
  const [trapId, setTrapId] = useState<number | null>(null);

  /**
   * Marker のアクティブ状態
   * クリックした Marker の camera_id をセットする
   * @example
   * setCameraId([camera_id])
   */
  const [cameraId, setCameraId] = useState<number | null>(null);

  /**
 * Marker のアクティブ状態
 * クリックした Marker の damage_id をセットする
 * @example
 * setDamageId([damage_id])
 */
  const [damageId, setDamageId] = useState<number | null>(null);

/**
 * 指示ピンMarker のアクティブ状態
 * クリックした Marker の damage_id をセットする
 * @example
 * setIndpinId([damage_id])
 */
    const [indpinId, setIndpinId] = useState<number | null>(null);

  /**
   * 検索結果テーブルのアクティブ行 ID
   */
  const [rowSelectedId, setRowSelectedId] = useState<number | null>(null);

  /**
   * 円形マーカーの表示座標
   */
  const [targetPosition, setTargetPosition] = useState<{
    lat: number;
    lng: number;
  } | null>();

  /**
   * 検索時データ作成_(watchKinds変更対応)
   */
  useMemo(() =>{
    if(data2 && trap_d2 && camera_d2 && damage_d2){
    data = Object.assign({}, data2);
    trap_d = Object.assign({}, trap_d2);
    camera_d = Object.assign({}, camera_d2);
    damage_d = Object.assign({}, damage_d2);
    if(data.limit && !searchCheck){
      limit = data.limit;
    }else{
      limit = null;
    }
    if(searchCheck){
      switch (proc) {
        case "vermin":
          data.features = vermins;
          break;
        case "trap":
          trap_d.features = vermins;
          break;
        case "camera":
          camera_d.features = vermins;
          break;
        case "damage":
          damage_d.features = vermins;
          break;
      }
    }
  }
  }, [searchCheck,vermins,data2,trap_d2,camera_d2,damage_d2]);

  /**
   * Google Map API リクエスト hook
   */
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: `${process.env.REACT_APP_DEV_GOOGLE_MAPS_API_KEY}`,
    libraries: ["visualization"],
    //language: 'jp', //日本語表示限定にする
  });

  /**
   * @param feature
   * Google Map APIの一部スタイルを作成
   * 柵の線の透明化及び色付け、ヒートマップの表示非表示を制御
   * @returns
   *  strokeColor: color,柵の色
   *  strokeOpacity: Opacity,柵の透明度(0or1)
   *  strokeWeight: 2,(柵の線の太さ)
   *  zIndex: 1
   */
  const MakeStyle = (feature: any) => {
    //柵の種別IDを取得　user_kind_id
    let type_id = feature.getProperty('prev_faci_type_id');
    let p_displayability = feature.getProperty('prev_faci_displayability');//230707追記
    let p_client = feature.getProperty('prev_faci_client');//230707追記client_code":1380001004696,"
    let use_kind_id = cookie?.verminData?.user_kind_id ? Number(cookie?.verminData?.user_kind_id) : 0;//230707追記
    let use_client = cookie?.verminData?.user_kind_id ? Number(cookie?.verminData?.client_code) : 0;//230707追記
    //柵の種別IDに応じて色分け
    let color = "#00FF00";
    if (type_id === 1) {
      color = "#ff0000";
    } else if (type_id === 2) {
      color = "#0093ff";
    } else if (type_id === 3) {
      color = "#9D00FF";
    };
    //出力制御行列に合わせて出力処理
    let Opacity = 0.0;
    if (shapedisplaycontrol.includes(type_id) && 
      (p_displayability == 0 || 
      (p_displayability <= use_kind_id && (p_client == use_client || use_client ==  1380001004696)))) {//230707条件追加
      Opacity = 1.0;
      if(co_na && p_client != co_na){
        Opacity = 0.0;
      }
    }
    return {
      strokeColor: color,
      strokeOpacity: Opacity,
      strokeWeight: 2,
      zIndex: 1
    };
  };

  /**
   * 柵の情報が読み取りでき次第発生する処理 230419修正
   */
  const Geo_Get = () =>{
    if (geoString2 !== undefined) {
      const deletedFilterList2 = geoString2.features.filter(function(value:any){
        if(co_na){
          return value.properties.prev_faci_client == co_na
        }else{
          return true
        }});
      const deletedFilterList = deletedFilterList2.filter(function(value:any){return value.properties.prev_faci_deleted == false});
      let prev_faci = geoString2;
      prev_faci.features = deletedFilterList;
      return prev_faci;
    }
    return geodatas;
  };

  useEffect(() => {
    if (geoString2 !== undefined) {
      geoString = Geo_Get();
      if (googleMap.current) {
        if((geoS_C != 2)){
          googleMap.current.data.addGeoJson(geoString);
          googleMap.current.data.setStyle(MakeStyle);
        }
        geoS_C = 1;
      }
    }
  }, [geoString2,googleMap.current,geoS_C,cookie?.verminData]);

  /**
   * 情報登録の際、害獣を選んだとき
 */
  const handleVerminModalOpen = useCallback(() => {
    setIsSelectCreateModal(false)
    createModalToggle()
  }, []);

  /**
* 情報登録の際、被害を選んだとき
*/
  const handleDamageModalOpen = useCallback(() => {
    setIsSelectCreateModal(false)
    createDamageModalOpen()
  }, []);

/**
* 情報登録の際、ピンを選んだとき
*/
const handleIndpinModalOpen = useCallback(() => {
  setIsSelectCreateModal(false)
  createIndpinModalOpen()
}, []);

/**
* 情報登録の際、罠を選んだとき
*/
const handleTrapModalOpen = useCallback(() => {
  setIsSelectCreateModal(false)
  createTrapModalOpen()
}, []);

/**
* 情報登録の際、カメラを選んだとき
*/
const handleCameraModalOpen = useCallback(() => {
  setIsSelectCreateModal(false)
  createCameraModalOpen()
}, []);

/**
* 情報登録の際、防止施設を選んだとき
*/
const handlePrevModalOpen = useCallback(() => {
  setIsSelectCreateModal(false)
  createPrevModalOpen()
}, []);

  /**
   * Googleマップ読み込みハンドラ
   * <GoogleMap /> が生成されたら実行される
   * @example
   * <GoogleMap onLoad={handleMapLoad} ... />
   */
  const handleMapLoad = useCallback((map: google.maps.Map) => {
    // コンポーネント内から Maps インスタンスオブジェクトを参照できるように React Refs に格納
    googleMap.current = map;
    geoString = Geo_Get();
    //googleMap.current.setMapTypeId("GsiMaps");//20230927追記 StreetMap用
    //googleMap.current.mapTypes.set("GsiMaps", getMapOption2('a', 'png', 18, 10));//20230927追記 StreetMap用
    if (googleMap.current) {
      if (geoS_C == 0 && geoString2 !== undefined){
        googleMap.current.data.addGeoJson(geoString);
        googleMap.current.data.setStyle(MakeStyle);
        geoS_C = 2;
      }
    }
  }, []);

  /**
   * ズームインハンドラ
   * [+]ボタンをクリックしたとき実行される
   * @example
   * <button onClick={handleZoomIn}>...</button>
   */
  const handleZoomIn = () => {
    googleMap.current.setZoom(googleMap.current.zoom + 1);
  };

  /**
   * ズームアウトハンドラ
   * [-]ボタンをクリックしたとき実行される
   * @example
   * <button onClick={handleZoomOut}>...</button>
   */
  const handleZoomOut = () => {
    googleMap.current.setZoom(googleMap.current.zoom - 1);
  };

  /**
   * Home 座標に戻るハンドラ
   * [home]ボタンをクリックしたとき実行される
   * @example
   * <button onClick={handleHomeBack}>...</button>
   */
  const handleHomeBack = () => {
    googleMap.current.setCenter(initialCenter);
  };

  /**
   * ドロワーボックスを開くハンドラ
   * ウインドウ左から現れる
   * @example
   * <button onClick={handleDrawerOpen}>...</button>
   */
  const handleDrawerOpen = () => {
    dropClose();
    setDrawerOpen(true);
  };

  /**
   * ドロワーボックスを閉めるハンドラ
   * ウインドウ左に隠れる
   * @example
   * <button onClick={handleDrawerClose}>...</button>
   */
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  /**
   * 背景地図メニュー開閉ハンドラ
   * @example
   * <button onClick={handlePopupToggle}>...</button>
   */
  const handlePopupToggle = () => {
    setPopup(!popup);
  };

  /**
   * 情報登録選択モーダルフラグ
   */
  const [isSelectCreateModal, setIsSelectCreateModal] = useState(false);

  /**
   *  地理院地図を指定するときにオプション
   * @example
   * googleMap.current.mapTypes.set("GsiMaps", getMapOption('std', 'png', zmax, zmin)
   */
  const getMapOption = (tileType: any, tileExtension: any, zoomMax: any, zoomMin: any) => {
    return {
      name: "地理院地図(GSI Maps)",
      tileSize: new google.maps.Size(256, 256),
      minZoom: zoomMin,
      maxZoom: zoomMax,
      getTile: (tileCoord: any, zoom: any, ownerDocument: any) => {
        const img = ownerDocument.createElement("img")
        img.id = 'gsi-map-layer-image'
        img.style.width = "256px"
        img.style.height = "256px"
        const x = (tileCoord.x % Math.pow(2, zoom)).toString()
        const y = tileCoord.y.toString()
        img.src = 'https://cyberjapandata.gsi.go.jp/xyz/' + tileType + '/' + zoom + '/' + x + '/' + y + '.' + tileExtension
        return img
      }
    }
  };

  /**
   *  Openstreetmapを指定するときにオプション
   * @example
   * googleMap.current.mapTypes.set("GsiMaps", getMapOption('std', 'png', zmax, zmin)
   */
    const getMapOption2 = (tileType: any, tileExtension: any, zoomMax: any, zoomMin: any) => {
      return {
        name: "OpenStreetMap",
        tileSize: new google.maps.Size(256, 256),
        minZoom: zoomMin,
        maxZoom: zoomMax,
        getTile: (tileCoord: any, zoom: any, ownerDocument: any) => {
          const img = ownerDocument.createElement("img")
          img.id = 'gsi-map-layer-image'
          img.style.width = "256px"
          img.style.height = "256px"
          const x = (tileCoord.x % Math.pow(2, zoom)).toString()
          const y = tileCoord.y.toString()
          img.src = 'http://'+tileType+'.tile.opencyclemap.org/cycle/' + zoom + '/' + x + '/' + y + '.' + tileExtension
          return img
        }
      }
    };

  /**
   * マップタイプ変更ハンドラ
   * - ROADMAP デフォルトの地図
   * - SATELLITE 航空写真の地図
   * - HYBRID 航空写真にロードマップのアイコンを表示した地図
   * - TERRAIN 地形を強調したロードマップ
   * @example
   * <Checkbox onChange={handleMapTypeChange} ... />
   */
  const handleMapTypeChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === 'GsiMaps') {
      googleMap.current.setMapTypeId(event.target.value);
      googleMap.current.mapTypes.set("GsiMaps", getMapOption('std', 'png', 18, 10));
    } else if (event.target.value === 'OSM') { //230927追加
      googleMap.current.setMapTypeId("GsiMaps");//230927追加
      googleMap.current.mapTypes.set("GsiMaps", getMapOption2('a', 'png', 18, 10));//230927追加
    } else {
      googleMap.current.setMapTypeId(event.target.value);
    }
  }, []);

  /**
   * 編集モード起動時、マップ上クリックでモーダル出現
   */
  function onEnter(e: any) {
    setLatLng({ lat: e.latLng.lat(), lng: e.latLng.lng() })
    setEditModeClose();
    setIsSelectCreateModal(true)
  }

  /**
   * 線入力モード起動、専用の線の軌跡表示　20230412追記
   */
  const [todoList, setTodoList] = useState([{lat: 0, lng: 0}]);
  const onLineEnter = (e: any) => {
    //情報登録
    if(Line){
      setTodoList(Line);
      setTodoList([
          ...todoList,
          { lat: e.latLng.lat(), lng: e.latLng.lng() }
        ]);
    }else{
      setTodoList([{ lat: e.latLng.lat(), lng: e.latLng.lng() }]);
    }
    setLines(todoList);
  }
  /**
   * 直線入力モード終了
   * 本番ではLine用の登録画面の開き直し
   */
  const navigate = useNavigate();//20230413追記
  function endLine() {
    if(Line){
      setLines(todoList);
    }
    setLineModeClose();
    handlePrevModalOpen();
    if(Page){
      navigate(Page)
    }
  }
  /**
   * 直線情報1つ戻る処理
   */
  const onLineBack = () => {
    if(todoList.length > 1 ){
      const last_index = todoList.length-1;
     setTodoList(
       todoList.filter((todoList, index) => (index !== last_index))
     );
     setLines(todoList);
   }else if(todoList.length == 1 ){
     setTodoList([{lat: 0, lng: 0}]);
     deleteLines();
   }
  }
  /**
 * 柵情報出力ハンドラ
 * - Fance1 電気柵の情報
 * - Fance2 ワイヤーメッシュの情報
 * - Fance3 ワイヤーメッシュの情報
 * - Fance4 その他の情報
 * @example
 * <Checkbox onChange={handleMapTypeOutput} ... />
 */
  const handleFenceTypeOutput = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      shapedisplaycontrol.push(Number(event.target.value));
    } else {
      let shapedisplaycontrolsub = shapedisplaycontrol.filter(function (hapedisplaycontrol) {
        return hapedisplaycontrol !== Number(event.target.value);
      });
      shapedisplaycontrol = shapedisplaycontrolsub;
    }
    googleMap.current.data.setStyle(MakeStyle)
  }, []);

  /**
   * ヒートマップ用データ作成処理 20230420標準偏差を使用する形式に変更
   */
  const HeatDataMake = () => {
    if (googleMap.current) {
      Hdata = [];
      //let Max = 1;
      let min= 100;
      let All = 0;
      // console.log("Htest0:20250403");
      for (let i = 0; i < data.features.length; i++) {
        if (watchKinds.includes(String(data.features[i].vermin_kind_id)) //2025/03/03 修正 Uduki
         && watchEcology.includes(ecology[+data.features[i].vermin_ecology]) //2025/03/03 修正 Uduki
         && !(data.features[i].vermin_is_deleted)
         && (co_na == null|| data.features[i].client_code == co_na)) {
          // console.log("Htest2:20250403");
          let count = 0;
          if(data.features[i].vermin_count){ count = data.features[i].vermin_count; }
          // console.log("Htest3:"+count);
          if(count > 0){
            All += count;
            let Heat_Sub = [{ location: new google.maps.LatLng(Number(data.features[i].vermin_latitude), Number(data.features[i].vermin_longitude)), weight: count }]
            Hdata = Hdata.concat(Heat_Sub);
          }
        }
      }
      let average = All/Hdata.length;
      let standard_deviation = 0;
      for(let i = 0; i < Hdata.length; i++){
        standard_deviation += (Hdata[i].weight-average)**2;
      }
      standard_deviation = Math.sqrt((standard_deviation/Hdata.length));
      if(standard_deviation == 0){ standard_deviation = 1; }
      for(let i = 0; i < Hdata.length; i++){
        Hdata[i].weight = (Hdata[i].weight-average)/standard_deviation
        if(min>Hdata[i].weight){
          min=Hdata[i].weight
        }
      }
      for(let i = 0; i < Hdata.length; i++){
        Hdata[i].weight = Hdata[i].weight-(2*min);
        //Hdata[i].weight = ((Hdata[i].weight-min)/(Max-min))*100+0.1
      }
      // console.log(Hdata);
    }
  };

  /**
   * ヒートマップ用データ作成_(watchKinds変更対応)
   */
  useMemo(() => {
    if(watchKinds_f.includes("2")){
      HeatDataMake();
    }
  }, [watchKinds,watchEcology,watchKinds_f,vermins]);

  //時間差処理
  /*useEffect(() => {
    setTimeout(() => {
      document.getElementById("t_m_E_t")!.style.opacity = "0";
      document.getElementById("t_m_E_t")!.style.transition=".5s";
    }, 10 * 1000);
    setTimeout(() => {
      document.getElementById("t_m_E_t")!.style.display = "none";
    }, 11 * 1000);
  },[]);*/

/**
 * 痕跡制御
 * @example
 * <Checkbox onChange={handleTraceOutput} ... />
 */
  const handleTraceOutput = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      let ECO_Che = watch('ecology').slice();
      ECO_Che.push('足跡', '糞便', '食痕', '掘り起こし');
      setValue('ecology',ECO_Che);
    } else {
      let ECO_Che = watch('ecology').slice().filter(item => (item.match("糞便")) == null).filter(item => (item.match("足跡")) == null).filter(item => (item.match("食痕")) == null).filter(item => (item.match("掘り起こし")) == null);
      setValue('ecology',ECO_Che);
    }
  }, []);

    /**
   * アイコンのタップのログをとる処理
   * @param vermin 
   */

  const Icon_Tap = (ids: Number ,kind : String ) => {
    axios.post(`${process.env.REACT_APP_DEV_API_URL}/tapicon`, {
      id: String(ids),
      category: kind,
      user: "OUT",
    })
  };

  /**
   * ショートカットハンドラ
   * - マップリセット機能 （初期座標に戻る,初期zoom値に戻る）
   */
  const handleKeyDown = (event: KeyboardEvent) => {
    // 「⌘ + 1」
    if (event.metaKey) {
      if (event.key === '1') {
        googleMap.current.setCenter(initialCenter);
        googleMap.current.setZoom(initialZoom);
      }
    }
  };

  /**
   * 害獣テーブル行選択ハンドラ
   * @example
   * <tr onClick={() => rowSelection(vermin)}>...</tr>
   */
  const rowSelection = useCallback((vermin: Vermin) => {
    const latlng = {
      lat: Number(vermin.vermin_latitude),
      lng: Number(vermin.vermin_longitude),
    };
    // マップ座標に移動する
    googleMap.current.setCenter(latlng);
    // テーブル行をアクティブにする
    setRowSelectedId(vermin.vermin_id);
    // 円形マーカーを表示する
    setTargetPosition(latlng);
    // マーカーを非選択状態にする
    setVerminId(vermin.vermin_id);
  }, []);

    /**
   * 被害テーブル行選択ハンドラ
   * @example
   * <tr onClick={() => rowSelection(vermin)}>...</tr>
   */
    const rowSelection_d = useCallback((damage: Damage) => {
      const latlng = {
        lat: Number(damage.damage_latitude),
        lng: Number(damage.damage_longitude),
      };
      // マップ座標に移動する
      googleMap.current.setCenter(latlng);
      // テーブル行をアクティブにする
      setRowSelectedId(damage.damage_id);
      // 円形マーカーを表示する
      setTargetPosition(latlng);
      // マーカーを非選択状態にする
      setDamageId(damage.damage_id);
    }, []);

  /**
   * 罠テーブル行選択ハンドラ
   * @example
   * <tr onClick={() => rowSelection(vermin)}>...</tr>
   */
       const rowSelection_t = useCallback((trap: Trap) => {
        const latlng = {
          lat: Number(trap.trap_latitude),
          lng: Number(trap.trap_longitude),
        };
        // マップ座標に移動する
        googleMap.current.setCenter(latlng);
        // テーブル行をアクティブにする
        setRowSelectedId(trap.trap_id);
        // 円形マーカーを表示する
        setTargetPosition(latlng);
        // マーカーを非選択状態にする
        setTrapId(trap.trap_id);
      }, []);
  /**
   * カメラテーブル行選択ハンドラ
   * @example
   * <tr onClick={() => rowSelection(vermin)}>...</tr>
   */
  const rowSelection_c = useCallback((camera: Camera) => {
    const latlng = {
      lat: Number(camera.camera_latitude),
      lng: Number(camera.camera_longitude),
    };
    // マップ座標に移動する
    googleMap.current.setCenter(latlng);
    // テーブル行をアクティブにする
    setRowSelectedId(camera.camera_id);
    // 円形マーカーを表示する
    setTargetPosition(latlng);
    // マーカーを非選択状態にする
    setCameraId(camera.camera_id);
  }, []);

  /**
   * 対象 Marker の InfoBox を開く処理
   * AnimalMarker コンポーネントに props で渡す
   * @example
   * <AnimalMarker activeMarker={activeMarker} ... />
   */
  const activeMarker = useCallback((vermin: Vermin) => {
    googleMap.current.setCenter({
      lat: Number(vermin.vermin_latitude),
      lng: Number(vermin.vermin_longitude),
    });
    Icon_Tap(vermin.vermin_id,"Vermin");
    setTrapId(null);
    setCameraId(null);
    setVerminId(vermin.vermin_id);
    setDamageId(null);
    setTargetPosition(null);
    setIndpinId(null);
  }, []);

  /**
   * InfoBox を閉じるハンドラ
   * AnimalMarker コンポーネントに props で渡す
   * @example
   * <AnimalMarker closeInfoBox={closeInfoBox} ... />
   */
  const closeInfoBox = useCallback(() => {
    setVerminId(null);
    setTargetPosition(null);
    setRowSelectedId(null);
  }, []);

  /**
   * 対象 Marker の InfoBox を開く処理
   * TrapMarker コンポーネントに props で渡す
   * @example
   * <TrapMarker t_activeMarker={t_activeMarker} ... />
   */
  const t_activeMarker = useCallback((trap: Trap) => {
    googleMap.current.setCenter({
      lat: Number(trap.trap_latitude),
      lng: Number(trap.trap_longitude),
    });
    Icon_Tap(trap.trap_id,"Trap");
    setCameraId(null);
    setVerminId(null);
    setTrapId(trap.trap_id);
    setDamageId(null);
    setTargetPosition(null);
    setIndpinId(null);
  }, []);

  /**
   * カメラの撮影頭数を保持する変数
   */
  let p_count: any[];

  /**
   * カメラの撮影頭数を保持する変数
   */
  let c_count: any[];

  /**
   * InfoBox を閉じるハンドラ
   * TrapMarker コンポーネントに props で渡す
   * @example
   * <TrapMarker closeInfoBox={closeInfoBox} ... />
   */
  const t_closeInfoBox = useCallback(() => {
    setTrapId(null);
    setTargetPosition(null);
    setRowSelectedId(null);
  }, []);

  /**
 * 対象 Camera の InfoBox を開く処理
 * CameraMarker コンポーネントに props で渡す
 * @example
 * <CameraMarker c_activeMarker={c_activeMarker} ... />
 */
  const c_activeMarker = useCallback((camera: Camera) => {
    googleMap.current.setCenter({
      lat: Number(camera.camera_latitude),
      lng: Number(camera.camera_longitude),
    });
    Icon_Tap(camera.camera_id,"Camera");
    setTrapId(null);
    setVerminId(null);
    setCameraId(camera.camera_id);
    setDamageId(null);
    setTargetPosition(null);
    setIndpinId(null);
  }, []);

  /**
   * InfoBox を閉じるハンドラ
   * TrapMarker コンポーネントに props で渡す
   * @example
   * <TrapMarker closeInfoBox={closeInfoBox} ... />
   */
  const c_closeInfoBox = useCallback(() => {
    setCameraId(null);
    setTargetPosition(null);
    setRowSelectedId(null);
  }, []);

  /**
* 対象 Damage の InfoBox を開く処理
* DamageMarker コンポーネントに props で渡す
* @example
* <DamageMarker d_activeMarker={d_activeMarker} ... />
*/
  const d_activeMarker = useCallback((damage: Damage) => {
    googleMap.current.setCenter({
      lat: Number(damage.damage_latitude),
      lng: Number(damage.damage_longitude),
    });
    Icon_Tap(damage.damage_id,"Damage");
    setTrapId(null);
    setVerminId(null);
    setCameraId(null);
    setDamageId(damage.damage_id);
    setTargetPosition(null);
    setIndpinId(null);
  }, []);

  /**
* InfoBox を閉じるハンドラ
* DamageMarker コンポーネントに props で渡す
* @example
* <DamageMarker d_closeInfoBox={d_closeInfoBox} ... />
*/
  const d_closeInfoBox = useCallback(() => {
    setDamageId(null);
    setTargetPosition(null);
    setRowSelectedId(null);
  }, []);

/**
* 対象 Indpin の InfoBox を開く処理
* IndpinMarker コンポーネントに props で渡す
* @example
* <IndpinMarker i_activeMarker={i_activeMarker} ... />
*/
const i_activeMarker = useCallback((indpin: Indpin) => {
  googleMap.current.setCenter({
    lat: Number(indpin.indpin_latitude),
    lng: Number(indpin.indpin_longitude),
  });
  Icon_Tap(indpin.indpin_id,"Indpin");
  setTrapId(null);
  setVerminId(null);
  setCameraId(null);
  setDamageId(null);
  setTargetPosition(null);
  setIndpinId(indpin.indpin_id);
}, []);

/**
* InfoBox を閉じるハンドラ
* IndpinMarker コンポーネントに props で渡す
* @example
* <IndpinMarker i_closeInfoBox={i_closeInfoBox} ... />
*/
const i_closeInfoBox = useCallback(() => {
  setIndpinId(null);
  setTargetPosition(null);
  setRowSelectedId(null);
}, []);

  /**
   * コンポーネントマウント時にショートカットキーをバインド
   * コンポーネントアンマウント時にショートカットキーを削除
   */
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    // クリーンアップ
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  /**
   * 鳥獣害種別チェックON/OFFがあれば、
   * 円形マーカーや選択行を消す
   */
  useEffect(() => {
    setVerminId(null);
    setTargetPosition(null);
    setRowSelectedId(null);
    //Heat_C = 1;
  }, [watchKinds]);

    /**
   * 検索結果をリセットするクリックハンドラ
   * @example
   * <Button onClick={handleSearchReset}>...</Button>
   */
     const handleSearchReset = useCallback(() => {
      reset();
      deleteVermins();
      deleteIds();
      searchE();
      setTargetPosition(null);
      deleteProc();
    }, [deleteVermins,deleteIds,reset,searchE]);

  if (loadError) {
    return (
      <p>Error</p>
    );
  }

  return (
    <>
      {isSelectCreateModal &&
        <div className={styles.modalWrapper}>
          <div className={styles.modalOverlay} onClick={() => {
            setIsSelectCreateModal(false)
            deleteLatLng()
            deleteLines()
          }}></div>
          <div className={styles.modalCard}>
            <Button onClick={handleVerminModalOpen}>害獣</Button>
            <Button onClick={handleTrapModalOpen}>罠</Button>
            <Button onClick={handleDamageModalOpen}>被害</Button>
            <Button onClick={handleCameraModalOpen}>カメラ</Button>
            <Button onClick={handlePrevModalOpen}>防止施設</Button>
            <Button onClick={handleIndpinModalOpen}>指示ピン</Button>
          </div>
        </div>
      }
      {isLoaded && (
        <>
          <div className={styles.container}>
            <button
              className={styles.zoomInButton}
              onClick={handleZoomIn}
              aria-label="ズームイン"
            >
              <IconPlus />
            </button>
            <button
              className={styles.zoomOutButton}
              onClick={handleZoomOut}
              aria-label="ズームアウト"
            >
              <IconMinus />
            </button>
            <button
              className={styles.homeBackButton}
              onClick={handleHomeBack}
              aria-label="ホーム位置に戻る"
            >
              <IconHome />
            </button>
            {/*<div className={styles.timeMenue} id="t_m_E_t"><b>▲詳細検索メニューを表示</b></div>230707コメントアウト*/}
            <button
              className={styles.drawerButton}
              onClick={handleDrawerOpen}
              aria-label="表示レイヤーボックスを表示する"
            >
              <IconLayers />
            </button>
            <button
              className={clsx(styles.popupButton, drawerOpen && styles.drawerOpen)}
              onClick={handlePopupToggle}
              aria-label="背景地図選択ボックスを開く"
            >
              <IconGrid />
            </button>
            {vermins && searchCheck &&
            (<Button className={styles.resetButton} onClick={handleSearchReset}>リセット</Button>)}
            <fieldset className={
              clsx(
                styles.fieldset,
                styles.popupBox,
                drawerOpen && styles.drawerOpen,
                popup && styles.isActive
              )
            }>
              <div className={styles.fieldsetInner}>
                <p className={styles.fieldsetLabel}>背景地図</p>
                <div className={styles.checkboxRow}>
                  {/* チェックボックスコンポーネントでラジオボタンの動作 */}
                  <Checkbox
                    type="radio"
                    name="mapTypeId"
                    value={google.maps.MapTypeId.ROADMAP}
                    label="ロードマップ"
                    bgImage={imgRoadmap}
                    onChange={handleMapTypeChange}
                    defaultChecked={true}
                  />
                  <Checkbox
                    type="radio"
                    name="mapTypeId"
                    value={google.maps.MapTypeId.SATELLITE}
                    label="航空写真"
                    bgImage={imgSatellite}
                    onChange={handleMapTypeChange}
                  />
                  <Checkbox
                    type="radio"
                    name="mapTypeId"
                    value={google.maps.MapTypeId.HYBRID}
                    label="ハイブリッド"
                    bgImage={imgHybrid}
                    onChange={handleMapTypeChange}
                  />
                  <Checkbox
                    type="radio"
                    name="mapTypeId"
                    value={google.maps.MapTypeId.TERRAIN}
                    label="地形"
                    bgImage={imgTerrain}
                    onChange={handleMapTypeChange}
                  />
                  <Checkbox
                    type="radio"
                    name="mapTypeId"
                    value={'GsiMaps'}
                    label="住宅地図"
                    bgImage={imgHousing}
                    onChange={handleMapTypeChange}
                  />
                  {/*<Checkbox /*追加日230927
                    type="radio"
                    name="mapTypeId"
                    value={'OSM'}
                    label="OpenStreetMap"
                    bgImage={imgOSM}
                    onChange={handleMapTypeChange}
                  />*/}
                </div>
              </div>
            </fieldset>
            <div className={clsx(styles.drawer, drawerOpen && styles.drawerOpen)}>
              <div className={styles.drawerHeader}>
                <i className={styles.drawerIcon}>
                  <IconLayers />
                </i>
                <p className={styles.drawerTitle}>レイヤー</p>
                <button
                  className={styles.closeButton}
                  onClick={handleDrawerClose}
                  aria-label="表示レイヤーボックスを閉じる"
                >
                  <IconClose />
                </button>
              </div>
              <div className={styles.drawerBody}>
                <fieldset className={styles.fieldset}>
                  <div className={styles.fieldsetInner}>
                    <p className={styles.fieldsetLabel}>鳥獣種別</p>
                    <div className={styles.checkboxRow} style={{ marginBottom:'5px'}}>
                      <Checkbox
                        type="checkbox"
                        value="1"
                        label="イノシシ"
                        bgImage={picBoar}
                        {...register('kinds')}
                      />
                      <Checkbox
                        type="checkbox"
                        value="2"
                        label="クマ"
                        bgImage={picBear}
                        {...register('kinds')}
                      />
                      <Checkbox
                        type="checkbox"
                        value="3"
                        label="シカ"
                        bgImage={picDeer}
                        {...register('kinds')}
                      />
                      <Checkbox
                        type="checkbox"
                        value="4"
                        label="サル"
                        bgImage={picMonkey}
                        {...register('kinds')}
                      />
                    </div>
                    <div className={styles.checkboxRow} style={{justifyContent: 'normal'}}>{/*231004追加*/}
                      <Checkbox
                        type="checkbox"
                        value="5"
                        label="アライグマ"
                        bgImage={picRaccoon}
                        {...register('kinds')}
                      />
                      <Checkbox
                        type="checkbox"
                        value="6"
                        label="ハクビシン"
                        bgImage={picPalmcivet}
                        {...register('kinds')}
                      />
                      <Checkbox
                        type="checkbox"
                        value="7"
                        label="その他"
                        bgImage={picOther}
                        {...register('kinds')}
                      />
                    </div>
                  </div>
                  <div className={styles.fieldsetInner}>
                    <p className={styles.fieldsetLabel}>表示形式</p>
                    <RadiosWrap direction="column">
                      <Radio
                        //name="display_format"
                        value="1"
                        {...register_f('kinds')}
                        defaultChecked={true}
                      >
                        アイコン表示（発生場所）
                      </Radio>
                      <Radio
                        value="2"
                        {...register_f('kinds')}
                      //name="display_format"
                       disabled
                      >
                        ヒートマップ（分布図）<br />現在メンテナンス中
                      </Radio>
                      {/*<Radio
                        name="display_format"
                        value="3"
                        disabled={true}
                      >
                        集計（エリア集計）
                      </Radio>*/}
                    </RadiosWrap>
                  </div>
                  <div className={styles.fieldsetInner}>
                    <p className={styles.fieldsetLabel}>情報分類</p>
                    {/* radioコンポーネントをcheckboxとして使っている */}
                    <RadiosWrap direction="column">
                      <Radio
                        type="checkbox"
                        value="捕獲"
                        {...register('ecology')}
                      >
                        捕獲
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.914" viewBox="0 0 20 20.914"><rect width="20" height="20.914" stroke-width="1" stroke="#444" fill="#444" stroke-opacity="1" fill-opacity="30%"></rect></svg>
                        </i>
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="観察"
                        {...register('ecology')}
                      >
                        観察
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="狩猟"
                        {...register('ecology')}
                      >
                        狩猟
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.914" viewBox="0 0 20 20.914"><g transform="translate(-697 -434)"><path d="M0,0H20V20.914H0Z" transform="translate(697 434)" stroke="#444" fill="#444" stroke-width="1" fill-opacity="30%"></path></g><path d="M.354,14.354l-.707-.707,14-14,.707.707Z" fill="#f00" transform="translate(3 3)"></path><path d="M13.646,14.354l-14-14L.354-.354l14,14Z" transform="translate(3 3)" fill="#f00"></path></svg>
                        </i>
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="目撃"
                        {...register('ecology')}
                      >
                        目撃
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="痕跡"
                        onChange={handleTraceOutput}
                        defaultChecked={true}
                      >
                        痕跡
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="テレメトリー"
                        {...register('ecology')}
                      >
                        テレメトリー
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="錯誤捕獲"
                        {...register('ecology')}
                      >
                        錯誤捕獲
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.914" viewBox="0 0 20 20.914"><rect width="20" height="20.914" stroke-width="1" stroke="#f00" fill="#f00" stroke-opacity="1" fill-opacity="30%"></rect></svg>
                        </i>
                      </Radio>
                    </RadiosWrap>
                  </div>
                  <input type="checkbox" id="痕跡" {...register('ecology')} style={{display: 'none'}} value="足跡"/>
                  <input type="checkbox" id="痕跡" {...register('ecology')} style={{display: 'none'}} value="糞便"/>
                  <input type="checkbox" id="痕跡" {...register('ecology')} style={{display: 'none'}} value="食痕"/>
                  <input type="checkbox" id="痕跡" {...register('ecology')} style={{display: 'none'}} value="掘り起こし"/>
                </fieldset>
                <fieldset className={styles.fieldset}>
                  <div className={styles.fieldsetInner}>
                    <p className={styles.fieldsetLabel}>鳥獣害対策設備</p>
                    <RadiosWrap direction='column'>
                      <Radio
                        type="checkbox"
                        value="罠"
                        // label="罠"
                        // bgImage={picselBox}
                        {...register('kinds')}
                      >
                        <i className={styles.fieldsetIcon} style={{ fontSize: '18px' }} aria-hidden={true}><IconBox /></i>罠
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="カメラ"
                        // label="カメラ"
                        // bgImage={picselBox}
                        {...register('kinds')}
                      >
                        <i className={styles.fieldsetIcon} style={{ fontSize: '18px' }} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g transform="translate(20 20) rotate(180)"><rect width="20" height="20" rx="3" transform="translate(0 0)" fill="#00e2ff" /><path d="M8.864,2.211,12.713.916a.755.755,0,0,1,.629.068.59.59,0,0,1,.294.5V5.792a.59.59,0,0,1-.293.5.754.754,0,0,1-.627.069L8.864,5.076v.985A1.3,1.3,0,0,1,7.5,7.273H1.364A1.3,1.3,0,0,1,0,6.061V1.212A1.3,1.3,0,0,1,1.364,0H7.5A1.3,1.3,0,0,1,8.864,1.212v1Z" transform="translate(3.182 6.364)" fill="##f4aaa4" fill-rule="evenodd" /></g></svg>
                          {/* <IconCamera /> */}
                        </i>カメラ
                      </Radio>

                      <Radio
                        type="checkbox"
                        value='2'
                        {...register('d_kinds')}
                        defaultChecked={SelectAN_Check}
                      >
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.914" viewBox="0 0 20 20.914"><path d="M10,20.914a1.125,1.125,0,0,1-.7-.248l-1.74-1.4a1.124,1.124,0,0,0-.7-.247l-.058,0-2.231.111H4.511A1.122,1.122,0,0,1,3.43,18.3l-.584-2.156a1.114,1.114,0,0,0-.469-.644L.507,14.279a1.127,1.127,0,0,1-.435-1.337l.8-2.087a1.116,1.116,0,0,0,0-.8L.072,7.97A1.127,1.127,0,0,1,.507,6.634l1.87-1.221a1.12,1.12,0,0,0,.469-.645L3.43,2.61a1.123,1.123,0,0,1,1.081-.828h.056L6.8,1.9h.055a1.127,1.127,0,0,0,.7-.247L9.3.248a1.119,1.119,0,0,1,1.406,0l1.74,1.4a1.126,1.126,0,0,0,.7.247H13.2l2.232-.112h.056a1.123,1.123,0,0,1,1.081.828l.584,2.157a1.118,1.118,0,0,0,.468.645l1.871,1.221a1.112,1.112,0,0,1,.434,1.336l-.795,2.087a1.107,1.107,0,0,0,0,.8l.795,2.088a1.126,1.126,0,0,1-.434,1.337L17.62,15.5a1.111,1.111,0,0,0-.468.644L16.568,18.3a1.122,1.122,0,0,1-1.081.828h-.056L13.2,19.018l-.058,0a1.119,1.119,0,0,0-.7.247l-1.741,1.4A1.122,1.122,0,0,1,10,20.914ZM5.89,5.406s-.007,0-.01.01a2.362,2.362,0,0,0,.679,1.556,3.706,3.706,0,0,0-1,.434,3.2,3.2,0,0,0-.984.947A3.751,3.751,0,0,0,4.09,9.419a4.425,4.425,0,0,0-.166,1.213,4.7,4.7,0,0,0,1.092,3.016,5.112,5.112,0,0,0,1.968,1.427,7.758,7.758,0,0,0,3.016.55,7.988,7.988,0,0,0,2.732-.439,5.537,5.537,0,0,0,1.5-.819,4.693,4.693,0,0,0,1.4-1.745,4.742,4.742,0,0,0,.44-1.989,4.459,4.459,0,0,0-.165-1.213,3.757,3.757,0,0,0-.485-1.066,3.165,3.165,0,0,0-.621-.687,3.566,3.566,0,0,0-1.145-.628c-.07-.023-.144-.045-.234-.069A2.782,2.782,0,0,0,14.2,5.355s0-.006-.006-.006-.012.009-.021.027a9.051,9.051,0,0,1-2.2,1.238,5.967,5.967,0,0,0,.957-1.856.277.277,0,0,1-.03.029,17.536,17.536,0,0,1-2.149,1.707A17.143,17.143,0,0,1,10,4.5a9.3,9.3,0,0,0-.448,1.88,4.3,4.3,0,0,1-1.6-1.729c-.031-.077-.059-.117-.085-.117s-.027.012-.039.036A3.075,3.075,0,0,0,8.3,6.713l-.017,0-.01,0-.012,0-.012,0C8.222,6.709,8.2,6.7,8.171,6.7A11.251,11.251,0,0,1,5.908,5.423C5.9,5.412,5.895,5.406,5.89,5.406ZM10,14.756a7.132,7.132,0,0,1-2.436-.387,4.662,4.662,0,0,1-1.269-.688,3.837,3.837,0,0,1-1.5-3.048,3.583,3.583,0,0,1,.133-.977A2.9,2.9,0,0,1,5.3,8.834a2.325,2.325,0,0,1,.452-.5,2.718,2.718,0,0,1,.868-.474,2.93,2.93,0,0,1,.927-.155,2.272,2.272,0,0,1,.508.055,1.334,1.334,0,0,1,.373.143l.089-.148c.137-.041.273-.077.406-.106A5.16,5.16,0,0,1,10,7.517a4.406,4.406,0,0,1,.579.042,6.493,6.493,0,0,1,.726.147c.075.02.136.038.185.052l.088.148a1.336,1.336,0,0,1,.373-.143,2.272,2.272,0,0,1,.508-.055,2.877,2.877,0,0,1,.614.067,2.918,2.918,0,0,1,.911.367,2.378,2.378,0,0,1,.722.692,2.93,2.93,0,0,1,.372.822,3.618,3.618,0,0,1,.132.977,3.883,3.883,0,0,1-.283,1.446,3.814,3.814,0,0,1-.608,1.012,4.262,4.262,0,0,1-1.639,1.184A6.912,6.912,0,0,1,10,14.756ZM6.126,9.406a3.171,3.171,0,0,0-.243,1.23A3.239,3.239,0,0,0,6,11.5a3.125,3.125,0,0,0,.38.859l.523-.333a2.51,2.51,0,0,1-.305-.69,2.645,2.645,0,0,1-.093-.7A2.56,2.56,0,0,1,6.7,9.65Z" transform="translate(0 0)" fill="red" /></svg>
                        </i>
                        農産物被害
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="4"
                        defaultChecked={SelectAN_Check}
                        {...register('d_kinds')}
                      >
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.914" viewBox="0 0 20 20.914"><path d="M10,20.914a1.125,1.125,0,0,1-.7-.248l-1.74-1.4a1.124,1.124,0,0,0-.7-.247l-.058,0-2.231.111H4.511A1.122,1.122,0,0,1,3.43,18.3l-.584-2.156a1.114,1.114,0,0,0-.469-.644L.507,14.279a1.127,1.127,0,0,1-.435-1.337l.8-2.087a1.116,1.116,0,0,0,0-.8L.072,7.97A1.127,1.127,0,0,1,.507,6.634l1.87-1.221a1.12,1.12,0,0,0,.469-.645L3.43,2.61a1.123,1.123,0,0,1,1.081-.828h.056L6.8,1.9h.055a1.127,1.127,0,0,0,.7-.247L9.3.248a1.119,1.119,0,0,1,1.406,0l1.74,1.4a1.126,1.126,0,0,0,.7.247H13.2l2.232-.112h.056a1.123,1.123,0,0,1,1.081.828l.584,2.157a1.118,1.118,0,0,0,.468.645l1.871,1.221a1.112,1.112,0,0,1,.434,1.336l-.795,2.087a1.107,1.107,0,0,0,0,.8l.795,2.088a1.126,1.126,0,0,1-.434,1.337L17.62,15.5a1.111,1.111,0,0,0-.468.644L16.568,18.3a1.122,1.122,0,0,1-1.081.828h-.056L13.2,19.018l-.058,0a1.119,1.119,0,0,0-.7.247l-1.741,1.4A1.122,1.122,0,0,1,10,20.914Zm-.093-9.383h.19v4.433a.587.587,0,0,0,1.174,0V8.325h.206v2.814a.446.446,0,0,0,.893,0V7.717a1.149,1.149,0,0,0-1.03-1.03H8.663a1.149,1.149,0,0,0-1.03,1.03v3.423a.447.447,0,0,0,.894,0V8.325h.206v7.639a.587.587,0,0,0,1.174,0V11.532ZM10,4.362a1.018,1.018,0,1,0,1.019,1.019A1.02,1.02,0,0,0,10,4.362Z" transform="translate(0 0)" fill="red" /></svg>
                        </i>
                        人的被害
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="5"
                        defaultChecked={SelectAN_Check}
                        {...register('d_kinds')}
                      >
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.914" viewBox="0 0 20 20.914"><path d="M10,20.914a1.125,1.125,0,0,1-.7-.248l-1.74-1.4a1.124,1.124,0,0,0-.7-.247l-.058,0-2.231.111H4.511A1.122,1.122,0,0,1,3.43,18.3l-.584-2.156a1.114,1.114,0,0,0-.469-.644L.507,14.279a1.127,1.127,0,0,1-.435-1.337l.8-2.087a1.116,1.116,0,0,0,0-.8L.072,7.97A1.127,1.127,0,0,1,.507,6.634l1.87-1.221a1.12,1.12,0,0,0,.469-.645L3.43,2.61a1.123,1.123,0,0,1,1.081-.828h.056L6.8,1.9h.055a1.127,1.127,0,0,0,.7-.247L9.3.248a1.119,1.119,0,0,1,1.406,0l1.74,1.4a1.126,1.126,0,0,0,.7.247H13.2l2.232-.112h.056a1.123,1.123,0,0,1,1.081.828l.584,2.157a1.118,1.118,0,0,0,.468.645l1.871,1.221a1.112,1.112,0,0,1,.434,1.336l-.795,2.087a1.107,1.107,0,0,0,0,.8l.795,2.088a1.126,1.126,0,0,1-.434,1.337L17.62,15.5a1.111,1.111,0,0,0-.468.644L16.568,18.3a1.122,1.122,0,0,1-1.081.828h-.056L13.2,19.018l-.058,0a1.119,1.119,0,0,0-.7.247l-1.741,1.4A1.122,1.122,0,0,1,10,20.914ZM9.6667,4.6667L4.333,9.3333L15.0,9.3333ZM6.4444,9.6667L6.4444,14.6667L12.8888,14.6667L12.8888,9.6667ZM11.3333,4.3333L11.3333,6.125L12.8667,7.4667L12.8667,4.3333Z" transform="translate(0 0)" fill="red" /></svg>
                        </i>
                        生活環境被害
                    </Radio>

                      <Radio
                        type="checkbox"
                        value="1"
                        defaultChecked={SelectAN_Check}
                        {...register('d_kinds')}
                      >
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18.376" viewBox="0 0 20 18.376"><g transform="translate(2 2)"><path d="M16,13.225a1,1,0,0,1-.4.856,1.574,1.574,0,0,1-.971.295H1.366a1.551,1.551,0,0,1-.97-.3,1.007,1.007,0,0,1-.4-.848,1.74,1.74,0,0,1,.259-.877L6.886.791A1.341,1.341,0,0,1,8.007,0,1.281,1.281,0,0,1,9.1.791l6.641,11.572a1.774,1.774,0,0,1,.259.863ZM9,5.88v-2.1H7v2.1a2.4,2.4,0,0,0,.029.381q.029.18.079.4t.079.381l.374,2.329H8.41L8.8,7.044q.029-.144.086-.374t.086-.41A2.4,2.4,0,0,0,9,5.88Zm0,5.564a.946.946,0,0,0-.295-.7.982.982,0,0,0-.712-.288.965.965,0,0,0-.7.288.946.946,0,0,0-.295.7.97.97,0,0,0,.295.712.953.953,0,0,0,.7.295A1.006,1.006,0,0,0,9,11.443Z" transform="translate(0 0)" fill="#ffeb00" /><path d="M14.636,14.376a1.573,1.573,0,0,0,.969-.295,1,1,0,0,0,.4-.856h0a1.774,1.774,0,0,0-.259-.863L9.1.791A1.281,1.281,0,0,0,8.007,0,1.341,1.341,0,0,0,6.886.791L.259,12.348A1.74,1.74,0,0,0,0,13.225a1.007,1.007,0,0,0,.4.848,1.551,1.551,0,0,0,.97.3h13.27M7.993,10.451a.982.982,0,0,1,.712.288.946.946,0,0,1,.295.7,1.006,1.006,0,0,1-1.006,1.006.953.953,0,0,1-.7-.295A.97.97,0,0,1,7,11.443a.946.946,0,0,1,.295-.7.965.965,0,0,1,.7-.288M7,3.781H9v2.1a2.4,2.4,0,0,1-.029.381q-.029.18-.086.41T8.8,7.044L8.41,9.373H7.562L7.188,7.044q-.029-.158-.079-.381t-.079-.4A2.4,2.4,0,0,1,7,5.88v-2.1m7.635,12.595H1.366a3.559,3.559,0,0,1-2.184-.712A3,3,0,0,1-2,13.227a3.717,3.717,0,0,1,.526-1.878L5.151-.2l.02-.034A3.256,3.256,0,0,1,8.007-2,3.191,3.191,0,0,1,10.838-.2l6.638,11.566.009.015A3.77,3.77,0,0,1,18,13.156q0,.034,0,.069a2.987,2.987,0,0,1-1.2,2.458A3.583,3.583,0,0,1,14.636,16.376Z" transform="translate(0 0)" fill="#050505" /></g></svg>
                        </i>
                        柵被害
                      </Radio>

                      <Radio
                        name="Fence"
                        type="checkbox"
                        value="1"
                        // label="2"
                        // bgImage={picselBox}
                        //disabled={true}
                        onChange={handleFenceTypeOutput}
                        defaultChecked={SelectAN_Check}
                      >
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="3" viewBox="0 0 20 3"><path d="M20,1.5H0v-3H20Z" transform="translate(0 1.5)" fill="#ff0000" /></svg>
                        </i>
                        電気柵
                      </Radio>

                      <Radio
                        name="Fence"
                        type="checkbox"
                        value="2"
                        // label="1"
                        // bgImage={picselBox}
                        //disabled={true}
                        onChange={handleFenceTypeOutput}
                        defaultChecked={SelectAN_Check}
                      >
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="3" viewBox="0 0 20 3"><path d="M20,1.5H0v-3H20Z" transform="translate(0 1.5)" fill="#0093FF" /></svg>
                        </i>
                        ワイヤーメッシュ柵
                      </Radio>
                      <Radio
                        name="Fence"
                        type="checkbox"
                        value="3"
                        // label="3"
                        // bgImage={picselBox}
                        //disabled={true}
                        onChange={handleFenceTypeOutput}
                        defaultChecked={SelectAN_Check}
                      >
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="3" viewBox="0 0 20 3"><path d="M20,1.5H0v-3H20Z" transform="translate(0 1.5)" fill="#9D00FF" /></svg>
                        </i>
                        複合柵
                      </Radio>
                      <Radio
                        name="Fence"
                        type="checkbox"
                        value="4"
                        // label="4"
                        // bgImage={picselBox}
                        //disabled={true}
                        onChange={handleFenceTypeOutput}
                        defaultChecked={SelectAN_Check}
                      >
                        <i className={styles.fieldsetIcon} aria-hidden={true}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="3" viewBox="0 0 20 3"><path d="M20,1.5H0v-3H20Z" transform="translate(0 1.5)" fill="#00FF00" /></svg>
                        </i>
                        その他
                      </Radio>
                      <Radio
                        type="checkbox"
                        value="指示ピン"
                        {...register('kinds')}
                      >
                        <img src={picPin} width="20" height="3" />
                        指示ピン
                      </Radio>
                    </RadiosWrap>
                  </div>
                </fieldset>
              </div>
            </div>
            {
              data ?
                <GoogleMap
                  onMouseDown={isEditMode ? onEnter : (!isEditMode && isLineMode) ? onLineEnter : () => { }}
                  mapContainerClassName={styles.googlemap}
                  center={initialCenter}
                  zoom={initialZoom}
                  clickableIcons={false}
                  onLoad={handleMapLoad}
                  //onLoad={FirstLoad}
                  options={{ ...googleMapOptions, gestureHandling: isEditMode ? 'none' : 'auto'}}
                >
                  {(data && !isEditMode && !isLineMode) && data.features.filter((vermin: Vermin) => watchEcology.includes(ecology[+vermin.vermin_ecology]))
                  .filter(() => watchKinds_f.includes("1"))
                  .filter((vermin: Vermin, i: any, array: any) => (array.findIndex((y: Vermin) => y.vermin_id === vermin.vermin_id) === i))
                  .filter((vermin: Vermin) => watchKinds.includes(String(vermin.vermin_kind_id)))
                  //upd-s 20240821 Tsuchiya Akane
                //.filter((vermin: Vermin) => (searchCheck && proc =="vermin" && ids.includes(vermin.vermin_id)) || !searchCheck)
                  .filter((vermin: Vermin) => (searchCheck  && ids.includes(vermin.vermin_id)) || !searchCheck)
                  .filter(() => proc =="vermin" || proc ==null)
                  //upd-e 20240821
               
                  .filter((vermin: Vermin) => !vermin.vermin_is_deleted)
                  .filter((vermin: Vermin) => !co_na || vermin.client_code == co_na)//230419追加
                  .map((vermin: Vermin) => (
                    <AnimalMarker
                      key={`animal_marker_${vermin.vermin_id}`}
                      vermin={vermin}
                      activeVerminId={verminId}
                      firstkind={SelectAN_STR}
                      activeMarker={activeMarker}
                      closeInfoBox={closeInfoBox}
                    />
                  ))
                  }

                  {watchKinds_f.includes("2") && <HeatmapLayer
                    // onLoad={HeatDataMake}
                    data={Hdata}
                    options={heatMapOptions}
                  />}
                  
                  {/*add-s 20241001 Tsuchiya Akane */}
                  {data.client_dps_flg &&  
                        <>
                      <Button className={styles.latest3DaysButton} onClick={() => handleLatestSearch(2)}>直近3日分</Button>
                      <Button className={styles.latest7DaysButton} onClick={() => handleLatestSearch(6)}>直近7日分</Button>
                        </>
                  }
                  {/*add-e 20241001 */}

                  {(trap_d && !isEditMode && !isLineMode)
                    && trap_d.features.filter(() => watchKinds.includes("罠")).filter((trap: Trap) => !trap?.trap_deleted)
                  //upd-s 20240821
//                  .filter((trap: Trap) => (ids.includes(trap.trap_id) && proc == "trap" && searchCheck) || !searchCheck)
                  .filter((trap: Trap) => (searchCheck  && ids.includes(trap.trap_id)) || !searchCheck)
                  .filter(() => proc =="trap" || proc ==null)
                  .filter((trap: Trap) => !co_na || trap.client_code == co_na)//230419追加
                  .map((trap: Trap) => {
                      c_count = catch_count?.list?.filter((value: any) => value?.trap_id === trap?.trap_id)
                      return (
                        <TrapMarker
                          key={`trap_marker_${trap.trap_id}`}
                          trap={trap}
                          activeTrapId={trapId}
                          t_activeMarker={t_activeMarker}
                          t_closeInfoBox={t_closeInfoBox}
                          catch_count={c_count}
                        />
                      )
                    })
                  }

                  {(camera_d && !isEditMode && !isLineMode)
                    && camera_d?.features.filter(() => watchKinds.includes("カメラ")).filter((camera: Camera) => !camera.camera_deleted)
//                .filter((camera: Camera) => (ids.includes(camera.camera_id) && proc =="camera" && searchCheck) || !searchCheck)
                  .filter((camera: Camera) => (searchCheck  && ids.includes(camera.camera_id)) || !searchCheck)
                  .filter(() => proc =="camera" || proc ==null)
                  .filter((camera: Trap) => !co_na || camera.client_code == co_na)//230419追加
                  .map((camera: Camera) => {
                    p_count = photo_count?.list?.filter((value: any) => value.camera_id === camera.camera_id)
                    return (
                      <CameraMarker
                        key={`camera_marker_${camera.camera_id}`}
                        camera={camera}
                        activeCameraId={cameraId}
                        c_activeMarker={c_activeMarker}
                        c_closeInfoBox={c_closeInfoBox}
                        photo_count={p_count}
                      />
                    )
                  })
                  }

                  {(damage_d && !isEditMode && !isLineMode) 
                    && damage_d?.features?.filter((damage: Damage, i: any, array: any) => (array.findIndex((y: Damage) => y.damage_id === damage.damage_id) === i))
                  .filter((damage: Damage) => watchKinds_d.includes(`${damage?.damage_type_id}`))
                  .filter((damage: Damage) => !damage.damage_deleted)
//                .filter((damage: Damage) => (ids.includes(damage.damage_id) && proc =="damage" && searchCheck) || !searchCheck)
                  .filter((damage: Damage) => (searchCheck  && ids.includes(damage.damage_id)) || !searchCheck)
                  .filter(() => proc =="damage" || proc ==null)
                  .filter((damage: Damage) => !co_na || damage.client_code == co_na)//230419追加
                  .map((damage: Damage) => {
                    return (
                      <DamageMarker
                        key={`damage_marker_${damage.damage_id}`}
                        damage={damage}
                        activeDamageId={damageId}
                        d_activeMarker={d_activeMarker}
                        d_closeInfoBox={d_closeInfoBox}
                      />
                    )
                  })
                  }

                  {(indpin_d && !isEditMode)
                    && indpin_d?.features?.filter((indpin: Indpin, i: any, array: any) => (array.findIndex((y: Indpin) => y.indpin_id === indpin.indpin_id) === i))
                  .filter(() => watchKinds.includes("指示ピン"))
                  .filter((indpin: Indpin) => !co_na || indpin.client_code == co_na)//230419追加
                  .filter((indpin: Indpin) => !indpin.indpin_deleted).map((indpin: Indpin) => {
                    return (
                      <IndpinMarker
                        key={`indpin_marker_${indpin.indpin_id}`}
                        indpin={indpin}
                        activeIndpinId={indpinId}
                        i_activeMarker={i_activeMarker}
                        i_closeInfoBox={i_closeInfoBox}
                      />
                    )
                  })
                  }
                  {/* 20230412追記 */}
                  {(isLineMode && !isEditMode && Line!=null)
                    && 
                    <Polyline
                    path={todoList}
                    options={{strokeColor:"#000000",strokeOpacity:1.0,strokeWeight:2 }}
                    />
                  }

                  {
                    <Polyline />
                  }

                  {/* 2025/04/17 Add Uduki 現在地表示用に追加 */}
                  {(myAicon)
                    && 
                    <Marker position={myAiconlatlng}
                      icon={{
                        fillColor: "#0000FF",                //塗り潰し色
                        fillOpacity: 1.0,                    //塗り潰し透過率
                        path: google.maps.SymbolPath.CIRCLE, //円を指定
                        //scale: 8,                          //円のサイズ
                        scale: myAiconSize.scale,            //円のサイズ
                        strokeColor: "#FFFFFF",              //枠の色
                        strokeOpacity: 1.0,                  //枠の透過率
                        // strokeWeight: 1.0                 //枠の幅  
                        strokeWeight: myAiconSize.stroke     //枠の幅
                      }}
                      zIndex={999}
                    />
                  }

                  {(limit && !isEditMode) &&//20230425追記
                  //<div className={styles.newQuote} style={{right:(width/2-128)+"px",bottom: "28px",color:"#FF0000",fontSize:"14px",WebkitTextStrokeWidth:"0.2px",WebkitTextStrokeColor:"#FFFFFF"}}>
                  /*<div>
                    <p className={styles.newQuote}>
                        <b>本日より{limit}日前までの情報を表示</b>
                    </p>
                  </div>*/
                  <div>
                    <p className={styles.newQuote}>
                        <b>表示期間　本日から何日前<br />
                        基本：{limit}日
                        {(data.limit_kinds) && data.limit_kinds?.filter((limit_kinds: Limit_Kinds) => watchKinds.includes(`${String(limit_kinds.lk_kind)}`))
                          .map((limit_kinds: Limit_Kinds) => {
                    return (<span>{vermin_category[limit_kinds.lk_kind]}：{limit_kinds.lk_limit}日</span>)})}
                        </b>
                    </p>
                  </div>
                  }
                  <div className={styles.fcomQuote}><a href="https://www.f-com.co.jp/" target="_blank" rel="noreferrer">https://www.f-com.co.jp/</a></div>
                  <div className={styles.Quote}>
                    <p>
                      出典：国土地理院
                    </p>
                    <a href="http://maps.gsi.go.jp/development/ichiran.html" target="_blank" rel="noreferrer">(http://maps.gsi.go.jp/development/ichiran.html)</a>
                  </div>

                  {(targetPosition && searchCheck ) && (
                    <Marker
                      position={targetPosition}
                      icon={{
                        url: markerCircle,
                        anchor: new google.maps.Point(26, 26),
                      }}
                      zIndex={1000}
                      clickable={false}/>
                  )}
                </GoogleMap>
                :
                <div className={styles.modalWrapper}>
                  <div className={styles.modalOverlay}>
                    <Oval
                      ariaLabel="loading-indicator"
                      height={75}
                      width={75}
                      strokeWidthSecondary={1}
                      color="#3a6468"
                      secondaryColor="white"
                    />
                  </div>
                </div>
            }
          </div>

          {isEditMode &&
            <div className={styles.editModeModal}>
              <div className={styles.editModalBox}>
                <p className={styles.editModalTitle}>
                  地点情報登録モード：
                </p>
                <p className={styles.editModalText}>
                  登録したい地点をクリックするとその地点の地点情報を登録できます。
                </p>
              </div>
              <Button className={styles.editModalButton} onClick={setEditModeClose}>モードを終了</Button>
            </div>
          }
          {/* 20230412追記 */}
          {(!isEditMode && isLineMode) &&
            <div className={styles.editModeModal}>
              <div className={styles.editModalBox}>
                <p className={styles.editModalTitle}>
                  防止施設情報登録モード：
                </p>
                <p className={styles.editModalText}>
                  登録したい防止施設の角となる地点をクリックすると線が引かれて登録できます。
                </p>
              </div>
              <Button className={styles.lefteditModalButton} onClick={onLineBack}>1つ戻る</Button>
              <Button className={styles.editModalButton} onClick={endLine}>位置情報登録</Button>
            </div>
          }

          {vermins && vermins.length !== 0 && proc == "vermin" && searchCheck &&
            (
              <Scrollbars className={styles.bottomTable} autoHeight autoHeightMax={190}>
                <Table>
                  <thead>
                    <tr>
                      <th>鳥獣種別</th>
                      <th>発生年月日</th>
                      <th>発生時刻</th>
                      <th>発生場所</th>
                      <th>生態情報</th>
                      <th>捕獲方法</th>
                      <th>頭数</th>
                      <th>群れ</th>
                      <th>ﾒｯｼｭ番号</th>
                      {/*<th>備考</th> 20250417 Del Uduki */}
                    </tr>
                  </thead>
                  <tbody>
                    {vermins.filter((vermin: Vermin) => watchKinds.includes(String(vermin.vermin_kind_id)))
                    .filter((vermin: Vermin) => !vermin.vermin_is_deleted)
                    .filter((vermin: Vermin) => watchEcology.includes(ecology[+vermin.vermin_ecology]))
                    .filter((vermin: Vermin) => !co_na || vermin.client_code == co_na)//230419追加
                    .map((vermin: Vermin) => (
                      <tr
                        key={`vermin_row_${vermin.vermin_id}`}
                        className={clsx(vermin.vermin_id === rowSelectedId && styles.rowSelected)}
                        onClick={() => rowSelection(vermin)}
                      >
                        <td>{vermin.vermin_kind_name}</td>
                        <td>{dayjs(vermin.vermin_discovery_date).format('YYYY/MM/DD')}</td>
                        <td>{dayjs(`${vermin.vermin_discovery_date} ${vermin.vermin_discovery_time}`).format('HH:mm')}</td>
                        <td>{vermin.vermin_address}</td>
                        <td>{vermin.vermin_ecology_name}</td>
                        <td>{vermin.trap_hunting_name}</td>
                        <td style={{ textAlign: 'right' }}>{vermin.vermin_count}</td>
                        <td>{vermin.vermin_herd}</td>
                        <td>{vermin.mesh_number}</td>
                        {/*<td>{vermin.vermin_remarks}</td> 20250417 Del Uduki */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Scrollbars>
            )}
            {vermins && vermins.length !== 0 && proc == "damage" && searchCheck &&
            (
              <Scrollbars className={styles.bottomTable} autoHeight autoHeightMax={190}>
                <Table>
                  <thead>
                    <tr>
                      <th>被害種別</th>
                      <th>加害害獣</th>
                      <th>発生日時</th>
                      <th>被害状況</th>
                      <th>対策実施状況</th>
                      <th>対策実施内容</th>
                      <th>備考</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vermins.filter((vermin: Damage) => watchKinds_d.includes(String(vermin.damage_type_id)))
                    .filter((vermin: Damage) => !co_na || vermin.client_code == co_na)//230419追加
                    /* .filter((vermin: Damage) => !vermin.damage_is_deleted).map((vermin: Damage) => ( */
                    .filter((vermin: Damage) => !vermin.damage_deleted).map((vermin: Damage) => (
                      <tr
                      key={`vermin_row_${vermin.damage_id}`}
                        className={clsx(vermin.damage_id === rowSelectedId && styles.rowSelected)}
                        onClick={() => rowSelection_d(vermin)}
                      >
                        <td>{vermin.damage_type_name}</td>
                        <td>{vermin.vermin_kind_name}</td>
                        <td>{vermin.damage_discovery_date}</td>
                        <td>{vermin.damage_contents}</td>
                        <td>{vermin.damage_implementation_name}</td>
                        <td>{vermin.damage_countermeasures}</td>
                        <td>{vermin.damage_remarks}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Scrollbars>
            )}
            {vermins && vermins.length !== 0 && proc == "trap" && searchCheck &&//searchCheck == 1 &&
            (
              <Scrollbars className={styles.bottomTable} autoHeight autoHeightMax={190}>
                <Table>
                  <thead>
                    <tr>
                      <th>罠種別</th>
                      <th>対策害獣</th>
                      <th>設置数</th>
                      <th>設置開始日</th>
                      <th>設置終了日</th>
                      <th>捕獲結果</th>
                      <th>錯誤捕獲</th>
                      <th>備考</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vermins.filter((vermin: Trap) => watchKinds.includes("罠"))
                    .filter((vermin: Trap) => !co_na || vermin.client_code == co_na)//230419追加
                    .filter((vermin: Trap) => !vermin.trap_deleted).map((vermin: Trap) => (
                      <tr
                      key={`vermin_row_${vermin.trap_id}`}
                        className={clsx(vermin.trap_id === rowSelectedId && styles.rowSelected)}
                        onClick={() => rowSelection_t(vermin)}
                      >
                        <td>{vermin.trap_hunting_name}</td>
                        <td>{vermin.vermin_kind_name}</td>
                        <td>{vermin.trap_count}</td>
                        <td>{vermin.trap_start}</td>
                        <td>{vermin.trap_stop}</td>
                        <td>{vermin.trap_result}</td>
                        <td>{vermin.trap_mistake_log}</td>
                        <td>{vermin.trap_remarks}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Scrollbars>
            )}
            {vermins && vermins.length !== 0 && proc == "camera" && searchCheck &&
            (
              <Scrollbars className={styles.bottomTable} autoHeight autoHeightMax={190}>
                <Table>
                  <thead>
                    <tr>
                      <th>カメラID</th>
                      <th>撮影開始日</th>
                      <th>撮影終了日</th>
                      <th>向き</th>
                      <th>備考</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vermins.filter((vermin: Camera) => watchKinds.includes("カメラ"))
                    .filter((vermin: Camera) => !co_na || vermin.client_code == co_na)//230419追加
                    .filter((vermin: Camera) => !vermin.camera_deleted).map((vermin: Camera) => (
                      <tr
                      key={`vermin_row_${vermin.trap_id}`}
                        className={clsx(vermin.trap_id === rowSelectedId && styles.rowSelected)}
                        onClick={() => rowSelection_c(vermin)}
                      >
                        <td>{vermin.camera_id}</td>
                        <td>{vermin.camera_start}</td>
                        <td>{vermin.camera_stop}</td>
                        <td>{vermin.camera_direction}</td>
                        <td>{vermin.camera_remarks}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Scrollbars>
            )}
        </>
      )}
    </>
  );
};

export default Home;
